
import {Enum} from '../../common/model/enum.model';

export class Carattere extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): Carattere[] {
    return [
      new Carattere('AMMINISTRATIVO'),
      new Carattere('RICERCA')
    ];
  }

}
